/* import __COLOCATED_TEMPLATE__ from './segment.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();